import { Link } from 'react-router-dom'
import useSiteRevampContent from '../content/useSiteRevampContent'
import trackEvent from '../utils/trackEvent'

export const BookDemoPrimaryButton = ({
  className = '',
  label,
}) => {
  const content = useSiteRevampContent()

  return (
    <Link
      to="/book-demo?path=form"
      onClick={() => trackEvent('cta_book_call_click', { source: 'shared_cta_button' })}
      className={`rounded-[8px] bg-gradient-to-r from-pyramid-1 via-pyramid-10 to-pyramid-19 px-6 py-3 font-semibold text-ebony shadow-lg shadow-pyramid-10/35 ${className}`.trim()}
    >
      {label || content.cta.bookCall}
    </Link>
  )
}

const BookDemoCta = ({
  className = '',
  title,
  body,
  align = 'left',
  compact = false,
}) => {
  const content = useSiteRevampContent()
  const isCenter = align === 'center'

  return (
    <section
      className={`rounded-2xl border border-white/10 ${
        compact
          ? 'bg-white/[0.04] p-5 md:p-6'
          : 'bg-gradient-to-br from-white/8 via-white/4 to-transparent p-7'
      } ${isCenter ? 'text-center' : 'text-left'} ${className}`.trim()}
    >
      <h2 className={`${compact ? 'text-xl' : 'text-2xl'} font-semibold text-white`}>
        {title || content.sharedCta.title}
      </h2>
      {!compact ? (
        <p className={`mt-3 text-slate-300 ${isCenter ? 'max-w-3xl mx-auto' : ''}`.trim()}>
          {body || content.sharedCta.body}
        </p>
      ) : null}
      <div className={`${compact ? 'mt-4' : 'mt-6'} flex flex-wrap gap-3 ${isCenter ? 'justify-center' : ''}`.trim()}>
        <BookDemoPrimaryButton className="px-5" />
      </div>
    </section>
  )
}

export default BookDemoCta
